module.exports = __webpack_public_path__ + "img/lissorhoptrus-oryzophilus.f1e9aded.jpg";